// @ts-strict

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { defaultImage } from '@app/core/helpers/constants';
import { IBannerData } from '@app/core/services/banners/banners.service.types';

@Component({
  selector: 'app-single-banner',
  templateUrl: './single-banner.component.html',
  styleUrls: ['./single-banner.component.scss']
})
export class SingleBannerComponent implements OnInit {
  @Input() bannerData?: IBannerData;
  @Output() selectedBannerData = new EventEmitter<IBannerData>();

  public bannerSize?: string;
  public readonly defaultImage = defaultImage;

  ngOnInit(): void {
    this.bannerSize = `${this.bannerData?.width || 0}x${this.bannerData?.height || 0}`;
  }

  public selectCurrentBanner(bannerData?: IBannerData): void {
    if (bannerData) this.selectedBannerData.emit(bannerData);
  }
}
